import { LineSegment } from "./LineSegment";
import { Point } from "./Point";
import { IGeometry } from "./IGeometry";
import { pairWise } from "@shared/common/utils/pairWise";
import { last } from "@shared/common/types/Array";

/**
 * Represents a 2D LineString geometry
 */
export class LineString implements IGeometry {
  private coordinates: Point[];

  constructor(coordinates: Point[]) {
    this.coordinates = coordinates;
  }

  toOrdinates(): number[] {
    return this.coordinates.flatMap((x) => x.toOrdinates());
  }

  toSegments(): LineSegment[] {
    return pairWise(this.coordinates).map((x) => new LineSegment(x[0], x[1]));
  }

  toCoordinates(): Point[] {
    return [...this.coordinates];
  }

  reverse(): LineString {
    return new LineString(this.coordinates.reverse());
  }

  touches(point: Point): boolean {
    return this.coordinates[0].equals(point) || last(this.coordinates).equals(point);
  }
}
